(function ($, gridBreakPoints) {
  function isBookingPage() {
    return typeof BOOKING_SETTINGS !== 'undefined';
  }

  function smoothScroll(hash) {
    const headerDesktop = 70;
    const headerMobile = 60;
    let height = $(window).width() > gridBreakPoints.lg ? headerDesktop : headerMobile;
    const adminBar = $('#wpadminbar');
    const duration = 700;

    if (adminBar.length) {
      height += adminBar.height();
    }

    const customOffset = height + 60;

    $('html,body').animate({ scrollTop: $(hash).offset().top - ($('.hero-menu').length ? customOffset : height) }, duration);

    window.setTimeout(() => {
      $(document).trigger('afterSmoothScroll', [hash]);
    }, duration);
  }

  function catchHash() {
    let className = null;

    if (window.location.hash.length) {
      className = `.${window.location.hash.substring(1)}`;
    }

    if (isBookingPage() || window.location.hash.includes('/')) {
      return false;
    }

    if (!$(window.location.hash).length) {
      if (window.location.hash.length && $(className).length) {
        smoothScroll(className);
      }
    }

    if (window.location.hash) {
      smoothScroll(window.location.hash);
    }

    return false;
  }

  function getLocation(href) {
    const link = window.document.createElement('a');
    link.href = href;
    return link;
  }

  function catchHashOnLoad() {
    // Nothing to align without an anchor. The unconditional reset this guard
    // replaced yanked users back to the top when the load event fired late
    // (slow hero/images on first visit) after they had already scrolled down
    // (MSPRET-8445).
    if (!window.location.hash.length || isBookingPage()) {
      return;
    }

    setTimeout(() => {
      catchHash();
    }, 700);
  }

  if (document.readyState === 'complete') {
    catchHashOnLoad();
  } else {
    window.addEventListener('load', catchHashOnLoad);
  }

  const allLinks = window.document.querySelectorAll('a[href*=\\#]:not([href=\\#])');

  allLinks.forEach((item) => {
    item.addEventListener('click', (event) => {
      if (isBookingPage()) {
        if (!$(event.target).hasClass('wpml-ls-native')) {
          event.preventDefault();
        }
        return false;
      }

      const itemLink = getLocation(item.href);
      const itemPathname = itemLink.pathname;
      const windowPathName = window.location.pathname;

      if (itemPathname.replace(/^\/|\/$/g, '') === windowPathName.replace(/^\/|\/$/g, '')) {
        event.preventDefault();
        window.history.pushState('', document.title, window.location.pathname + itemLink.hash);
        smoothScroll(itemLink.hash);
      }
      return false;
    });
  });

  // eslint-disable-next-line no-undef
}(jQuery, gridBreakPoints));
